export default {
    dealer_alert_logs_title: "Registro de Alertas del Distribuidor",
    dealer_alert_logs_id: "ID",
    dealer_alert_logs_timestamp: "Fecha/Hora",
    dealer_alert_logs_company_id: "Cuenta",
    dealer_alert_logs_device_id: "Dispositivo",
    dealer_alert_logs_filter_company: "Cuenta",
    dealer_alert_logs_filter_device: "Dispositivo",
    dealer_alert_logs_filter_date_range: "Rango de Fecha",
    dealer_alert_logs_alert_type: "Tipo de Alerta",
    dealer_alert_logs_payload: "Contenido",
    dealer_alert_logs_view: "Ver",
    dealer_alert_logs_webhook_status: "Estado del Webhook",
    dealer_alert_logs_webhook_sent_on: "Webhook Enviado",
    dealer_alert_logs_webhook_attempts: "Intentos de Webhook",
    dealer_alert_logs_from: "Desde",
    dealer_alert_logs_to: "Hasta",
    dealer_alert_logs_apply: "Aplicar",
    dealer_alert_logs_resend: "Reenviar Webhook",
    dealer_alert_logs_payload_viewer: "Visor de Contenido",
    dealer_alert_logs_error_loading: "Error cargando el registro de alertas",
};
